import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Footer from "./components/Footer/Footer";
import Navbar from "./components/Navbar/Navbar";
import Home from "./pages/Home";
import Login from "./pages/Login";

function App() {
  const [login, setLogin] = useState(false);
  const navigate = useNavigate();

  function logout() {
    localStorage.clear();
    setLogin(false);
    navigate("/login");
  }

  useEffect(() => {
    if (localStorage.getItem("login") === "true") {
      setLogin(true);
    } else {
      navigate("/login");
    }
  }, [window.location.href]);

  return (
    <div>
      {!login ? <></> : <Navbar logout={logout} login={login}/>}
      <Routes>
        <Route path="*" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
